(() => {
  const SELECTOR = '[data-es-profile-tabs]';

  function init(section) {
    if (!section || section.dataset.esProfileTabsReady === 'true') return;
    section.dataset.esProfileTabsReady = 'true';

    const tabs = Array.from(section.querySelectorAll('[data-family-tab]'));
    const cards = Array.from(section.querySelectorAll('[data-profile-family]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function showFamily(family, animate = true) {
      tabs.forEach((tab) => {
        const active = tab.dataset.familyTab === family;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });

      const visibleCards = [];
      cards.forEach((card) => {
        const visible = card.dataset.profileFamily === family;
        card.hidden = !visible;
        if (visible) visibleCards.push(card);
      });

      if (animate && !reducedMotion.matches) {
        visibleCards.forEach((card, index) => {
          card.animate(
            [
              { opacity: 0, transform: 'translateY(26px)' },
              { opacity: 1, transform: 'translateY(0)' }
            ],
            {
              duration: 500,
              delay: index * 70,
              easing: 'cubic-bezier(.16, 1, .3, 1)',
              fill: 'both'
            }
          );
        });
      }

      if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
        window.requestAnimationFrame(() => window.ScrollTrigger.refresh());
      }
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => showFamily(tab.dataset.familyTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();

        let nextIndex = index;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;

        tabs[nextIndex].focus();
        showFamily(tabs[nextIndex].dataset.familyTab);
      });
    });

    const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];
    if (activeTab) showFamily(activeTab.dataset.familyTab, false);
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
